import { render, staticRenderFns } from "./newArticles.vue?vue&type=template&id=2135bd3d&scoped=true&"
import script from "./newArticles.vue?vue&type=script&lang=js&"
export * from "./newArticles.vue?vue&type=script&lang=js&"
import style0 from "./newArticles.vue?vue&type=style&index=0&id=2135bd3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2135bd3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VDivider,VIcon,VImg,VListItem,VListItemContent,VToolbar,VToolbarTitle,VVirtualScroll})
